import {AccountingMatrixDatagridGrid} from '../../components/AccountingMatrixDatagridGrid';
import {getAccountingMatrixDatagridM202HeadersConfig} from './getAccountingMatrixDatagridM202HeadersConfig';

export function AccountingMatrixDatagridM202Headers() {
  return <AccountingMatrixDatagridGrid config={getAccountingMatrixDatagridM202HeadersConfig()} />;
}
